import React from "react";

function PravicyPolicy() {
  return (
   <div className="container">
  <h1>Privacy Policy</h1>
  <p>
    Welcome to <a href="https://latinsyrgold.com">latinsyrgold</a>, your trusted platform for financial services, including personal loans, EMI-based purchases, and digital finance solutions. At latinsyrgold, your privacy and trust are our top priorities.
  </p>

  <p>Contact Us:  +971563705658 | Address: Dubai  | Email:  info@latinsyrgold.com </p>

  <p>
    We are fully committed to protecting your financial and personal information. We collect only the information necessary to provide you with safe, secure, and seamless financial services. Here's how we handle your data:
  </p>

  <ul>
    <li>
      We collect personal and financial details only when you apply for a loan, EMI service, or create an account on our platform.
    </li>
    <li>
      This data is used strictly for loan processing, KYC verification, risk assessment, and regulatory compliance.
    </li>
    <li>
      latinsyrgold does not share your information with third parties unless legally required or for authorized financial processing (e.g., partner NBFCs or banks).
    </li>
    <li>
      We use secure encryption, safe servers, and advanced technology to keep your data safe from unauthorized access or misuse.
    </li>
    <li>
      We follow all RBI guidelines and Indian data protection regulations (such as the Digital Personal Data Protection Act, 2023).
    </li>
  </ul>

  <p>
    Your trust means everything to us. If you have any concerns or questions about how your data is handled, feel free to reach out to our support team anytime.
  </p>
</div>

  );
}

export default PravicyPolicy;
